// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rVcQ","col":"styles_col__1nS5H"};